import { dateFnsLocalizer } from "react-big-calendar";
import de from "date-fns/locale/de";
import en from "date-fns/locale/en-US";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
export const locales = {
  en,
  de,
};
export const getLocale = (language) => {
  const lang = language.split("-")[0];
  return locales[lang];
};
export const getLocalizedDate = (date, language, date_format = "P") => {
  if (!date) return null;
  return format(date, date_format, {
    locale: getLocale(language),
  });
};
export const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});
export const normalizeBrowserLanguage = (language) => {
  console.log("lang", language);
  switch (language) {
    case "en":
    case "en-US":
      return "en-US";
    case "de":
    case "de-DE":
      return "de-DE";
    default:
      return "en-US";
  }
};
